export default function ({ store }) {
  store.dispatch('articles/boot')
  store.dispatch('auth/boot')
  store.dispatch('categories/boot')
  store.dispatch('pages/boot')
  store.dispatch('products/boot')
  store.dispatch('quizzes/boot')
  store.dispatch('window/boot')
}
